import React, { useEffect, useState } from "react";
// import SelectField from "../SelectField/SelectField";
import { Button } from "../Button/Button";
import crossIcon from "../../assets/icons/cancelicon.png";
import VectorIcon from "../../assets/icons/Vector.png";

import "../../styles/navselect.css";
import { Link, useNavigate } from "react-router-dom";
import { IoGlobeSharp, IoMenu } from "react-icons/io5";
import axios from "axios";
import { apiToken, baseUrl } from "../../utils/base_url";
import DropDown from "./DropDown";
import { Drawer } from "antd";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1500px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _2200px,
  _991px,
} from "../../utils/mediaBreakpoints";

const Navbar = () => {
  const navigate = useNavigate();
  const [onHover, setOnHover] = useState(false);
  const [open, setOpen] = useState(false);
  const [dropDownDrawer, setDropDownDrawer] = useState(false);
  const [navbarData, setNavBarData] = useState({});
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _991 = useMediaQuery({ maxWidth: _991px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });

  useEffect(() => {
    const fetchNavigationBar = async () => {
      try {
        const res = await axios.get(
          `${baseUrl}/api/navigations?populate=links.dropdowns.link&populate=buttons`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );

        console.log(res?.data?.data[0]);

        setNavBarData(res?.data?.data[0]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchNavigationBar();
  }, [setNavBarData]);

  const onClose = () => {
    setOpen(false);
  };

  console.log(navbarData);
  return (
    <>
      {/* Navbar For Smaller And Medium Screen */}
      <Drawer
        className="navbar-bg "
        onClose={onClose}
        closeIcon={<img src={crossIcon} alt="" width={15} height={15} />}
        open={open}
        placement="left"
      >
        <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex align-items-center justify-content-between gap-4">
          {navbarData?.links?.map((data, idx) => {
            // console.log(data?.link);
            const link = data?.link;
            return (
              <li key={idx} className="nav-item">
                {data?.dropdowns?.length <= 0 ? (
                  <Link
                    className="nav-link  "
                    aria-current="page"
                    to={data?.link}
                  >
                    {data?.name}
                  </Link>
                ) : (
                  <div className="position-relative">
                    <span
                      className="nav-link cursor-pointer active"
                      aria-current="page"
                      style={{
                        border:
                          data?.link === "#mena" ? "1px solid #283950" : "",
                        borderRadius: data?.link === "#mena" ? "8px" : "",
                        padding: data?.link === "#mena" ? "10px" : "",
                      }}
                      onClick={() => {
                        setDropDownDrawer(data?.link);
                        console.log("clicked");
                      }}
                    >
                      {data?.name}
                    </span>

                    {dropDownDrawer == data?.link && (
                      <DropDown
                        link={link}
                        options={data?.dropdowns}
                        drawerItem={true}
                        mainPageName={data?.name}
                        open={dropDownDrawer}
                        setOpen={setDropDownDrawer}
                      />
                    )}
                  </div>
                )}
              </li>
            );
          })}
          {/* <li className="nav-item ">
            <Link className="nav-link  " aria-current="page" to={"/blogs"}>
              Blogs
            </Link>
          </li> */}
        </ul>

        <div className=" d-flex align-items-center  justify-content-center">
          <div className="d-flex align-items-center">
            {navbarData?.buttons?.map((data, idx) => (
              <React.Fragment key={idx}>
                <Button
                  children={data?.name}
                  onClick={() => {
                    if (data?.isExternal) {
                      window.open(data.link, "_blank", "noopener,noreferrer");
                    } else {
                      navigate(data?.link);
                    }
                  }}
                  className={"px-4 fs20 fw500"}
                  textColor={data?.textColor}
                  background={data?.backgroundColor}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </Drawer>

      <nav className="navbar navbar-bg nav-small-scrn position-sticky top-0 zindex-100 z-3 ">
        <div className="container contwidth gx-0">
          <div className="row w-100 gx-0">
            <div className="col-6 d-flex align-items-center justify-content-start">
              <Link className="navbar-brand text-white" to={"/"}>
                <span dangerouslySetInnerHTML={{ __html: navbarData?.logo }} />
              </Link>
            </div>
            <div className="col-6  d-flex align-items-center justify-content-end">
              <span
                className="cursor-pointer p-0"
                onClick={() => setOpen(true)}
              >
                <IoMenu color="white" size={30} />
              </span>
            </div>
          </div>
        </div>
      </nav>
      {/* End Here */}

      {/* Nav Bar For Bigger Screen */}
      <nav className="navbar navbar-bg navbar-expand-lg nav-big-scrn position-sticky top-0 zindex-100 z-3 py-2">
        <div
          className="container px-0 justify-content-between align-items-center contwidth"
          style={{ padding: "0 3.8rem" }}
        >
          <Link className="navbar-brand text-white" to={"/"}>
            <span dangerouslySetInnerHTML={{ __html: navbarData?.logo }} />
          </Link>

          <div className="d-flex align-items-center justify-content-between py-1">
            <ul
              className={`navbar-nav me-auto mb-2 mb-lg-0 d-flex align-items-center justify-content-between`}
              style={{ gap: _1200 ? "0.5rem" : _1600 ? "2.2rem" : "3rem" }}
            >
              {navbarData?.links?.map((data, idx) => {
                const link = data?.link;
                if (data?.link == "#mena") {
                  console.log(data);
                }
                return (
                  <li key={idx} className="nav-item ">
                    {data?.dropdowns?.length <= 0 ? (
                      <Link
                        className="nav-link  "
                        aria-current="page"
                        to={data?.link}
                      >
                        {data?.name}
                      </Link>
                    ) : (
                      <div className="position-relative">
                        <span
                          className="nav-link cursor-pointer active"
                          aria-current="page"
                          style={{
                            // border:
                            //   data?.link === "#mena"
                            //     ? "1px solid rgb(241, 241, 241)"
                            //     : "",
                            borderRadius: data?.link === "#mena" ? "8px" : "",
                          }}
                          // onMouseEnter={() => setOnHover(true)}
                          onMouseEnter={() => setOnHover(data?.link)}
                          onClick={() => navigate(data?.link)}
                        >
                          {/* {data?.link === "#mena" && (
                            <IoGlobeSharp className="me-2 ms-1" />
                          )} */}
                          {data?.name}
                          {/* {data?.link === "#mena" && (
                            <img className="ms-3 me-1" src={VectorIcon} />
                          )} */}
                        </span>
                        {onHover == data?.link && (
                          <DropDown
                            link={link}
                            options={data?.dropdowns}
                            setOnHover={setOnHover}
                          />
                        )}
                      </div>
                    )}
                  </li>
                );
              })}
              {/* <li className="nav-item ">
                <Link className="nav-link  " aria-current="page" to={"/blogs"}>
                  Blogs
                </Link>
              </li> */}
            </ul>
          </div>

          <div className=" d-flex align-items-center  justify-content-center">
            <div className="d-flex align-items-center gap-3">
              {navbarData?.buttons?.map((data, idx) => (
                <React.Fragment key={idx}>
                  <Button
                    children={data?.name}
                    onClick={() => {
                      if (data?.isExternal) {
                        window.open(data.link, "_blank", "noopener,noreferrer");
                      } else {
                        navigate(data?.link);
                      }
                    }}
                    newButtonClassName={"rounded-3 border-0  fw500 btnres"}
                    textColor={data?.textColor}
                    fontSize="14px"
                    background={data?.backgroundColor}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
